import { Menu } from 'antd';
import { MenuItemType } from 'antd/es/menu/hooks/useItems';
import { useMenuList } from 'constants/menu';
import React, { useEffect, useState } from 'react';
import { To, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import Routers from 'constants/routers';

function TCommonSidebar() {
  const { user } = useAuth();
  const userRole = user?.role;
  const menuList = useMenuList();
  const navi = useNavigate();
  const location = useLocation();
  const [defaultSelectedKeys, setDefautSelectedKeys] = useState<string>(location.pathname);

  const getHomePageByRole = () => {
    switch (userRole) {
      case 'leader':
      case 'board_of_directors':
      case 'chief_operating_officer':
        return Routers.Candidates;
      default:
        return Routers.Jobs;
    }
  }

  const filterMenuByRole = () => {
    let filteredList: any[] = [];
    switch (userRole) {
      case 'admin':
        filteredList = [...menuList];
        break;

      case 'human_resource':
        filteredList = menuList.filter((item) =>
          [
            '/job-management',
            '/articles-management',
            '/candidates-management',
            '/user-management',
            '/marathon-event',
            '/infomation',
            '/bod-interview-management',
            '/training-management',
            '/hashtag-management',
            '/test-management',
            '/auto-register'
          ].includes(item.key)
        );
        break;

      case 'training_coordinator':
        filteredList = menuList.filter((item) => ['/training-management', '/hashtag-management'].includes(item.key));
        break;

      case 'leader':
        filteredList = menuList.filter((item) => ['/candidates-management', '/test-management', '/auto-register'].includes(item.key));
        break;
      case 'board_of_directors':
      case 'chief_operating_officer':
        filteredList = menuList.filter((item) => ['/job-management','/candidates-management', '/bod-interview-management','/test-management', '/auto-register'].includes(item.key));
        break;

      default:
        filteredList = [];
        break;
    }

    // Đảm bảo chức năng 'Đăng ký tự động' luôn hiển thị trong Menu đối với bất cứ Role nào khi đã đăng nhập!
    const autoRegisterItem = menuList.find(item => item.key === '/auto-register');
    if (autoRegisterItem && !filteredList.some(item => item.key === '/auto-register')) {
      filteredList.push(autoRegisterItem);
    }

    return filteredList;
  };

  const roleBasedMenu = filterMenuByRole().map(item => ({
    ...item,
    icon: React.cloneElement(
      item.icon,
      {
        color: item.key === defaultSelectedKeys ? '#1D6EBE' : '#666666' // Đỏ khi active, xám khi thường
      }
    )
  }));

  const onSelect = (item: MenuItemType) => {
    navi(item.key as To);
  };

  useEffect(() => {
    setDefautSelectedKeys(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <div
        className="header__logo cursor-pointer"
        onClick={() => navi(`${getHomePageByRole()}`)}
        tabIndex={0}
      />
      <Menu theme="dark" mode="inline" selectedKeys={[defaultSelectedKeys]} onSelect={onSelect} items={roleBasedMenu} />
    </>
  );
}

export default TCommonSidebar;